module.exports = __webpack_public_path__ + "img/LT.1e4b2e3e.svg";